import "core-js/stable";
import "regenerator-runtime/runtime";
import './index.css';
import { DateTime } from 'luxon';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import CssBaseline from '@material-ui/core/CssBaseline';
import App from './App';
import configActions from './areas/config/actions';
import themeActions from './areas/theme/actions';
import authConstants from './areas/auth/constants';
import repository from './client/repository';
import storeBuilder from './store';
import appStore from 'utilities/store';
import Keys from 'stateKeys';
// import { init as initAppInsights } from "appInsights";

const rootElement = document.getElementById('root');

const triggerAndRender = (store, isLoggedIn) => {

    // Trigger an update to the logged in state
    store.dispatch({ type: authConstants.LOGGED_IN_SUCCESS, isLoggedIn });

    // Now the state is known, render the UI
    ReactDOM.render(
        <Provider store={store}>
            <CssBaseline>
                <App history={store.history} store={store} />
            </CssBaseline>
        </Provider>,
        rootElement);
};

const isStateValid = state => {

    const { location, auth } = state;
    if (!location || !location.valid) {
        return false;
    }

    if (auth && auth.loginDateTime) {
        const loginTime = DateTime.fromJSDate(auth.loginDateTime);
        const diff = loginTime.diffNow().as("minutes");
        if (Math.abs(diff) > process.env.SESSION_VALIDITY_MINUTES) {
            return false;
        }
    }

    return true;
};

storeBuilder().then(store => {

    store.dispatch(themeActions.getTheme());
    store.dispatch(configActions.getAppConfig());

    const state = store.getState();

    const valid = isStateValid(state);

    const { auth, config } = store.getState();

    // initAppInsights(config.instrumentationKey)

    if (!valid || auth.showLoginPage === true) {
        appStore.remove(Keys.Auth.TokenKey);
        triggerAndRender(store, false);
    } else {
        repository.auth.isLoggedIn().then(result => {
            triggerAndRender(store, result.isLoggedIn);
        });
    }
});

//registerServiceWorker();
